"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewSkeleton = void 0;
var preview_skeleton_component_1 = require("./preview-skeleton.component");
Object.defineProperty(exports, "PreviewSkeleton", { enumerable: true, get: function () { return preview_skeleton_component_1.PreviewSkeleton; } });
